import { Container, Nav, Navbar } from 'react-bootstrap';
import { useEffect, useState } from 'react';
import './MainNavbar.scss';
import { ReactComponent as ThinnectSmallLogo } from './../assets/icons/NN_logo.svg';
import { NavLink } from 'react-router-dom';
import useWindowSize from '../helpers/hooks/useWindowSize';
import { useAppSelector } from '../redux/hooks';
import deinitialization from '../helpers/deinitialization';
import NavDeviceList from './NavDeviceList';

const MainNavbar = () => {
	const windowSize = useWindowSize();
	const isLoggedIn = useAppSelector((state) => state.authentication.loggedIn);

	const [toggleNavbar, setToggleNavbar] = useState<boolean>(false);

	useEffect(() => {
		if (windowSize.width && windowSize.width > 768) {
			document.body.style.overflowY = '';
			setToggleNavbar(false);
		}
	}, [windowSize]);

	function toggleNavbarStatus(status: boolean): void {
		if (status !== toggleNavbar) {
			document.body.style.overflowY = !toggleNavbar ? 'hidden' : '';
			setToggleNavbar(status);
		}
	}

	function logout() {
		toggleNavbarStatus(false);
		deinitialization.userLogout(true);
	}

	return (
		<Navbar
			expand="md"
			variant="light"
			expanded={toggleNavbar}
			collapseOnSelect={true}
			data-bs-theme="light"
		>
			<Container fluid>
				<Navbar.Brand>
					<ThinnectSmallLogo style={{ height: '65px', width: '65px' }} />
				</Navbar.Brand>
				{isLoggedIn && (
					<Navbar.Toggle
						aria-controls="navbar-nav"
						onClick={() => toggleNavbarStatus(!toggleNavbar)}
					/>
				)}
				{isLoggedIn && (
					<Navbar.Collapse id="navbar-nav">
						<Nav className="ms-md-auto">
							<Nav.Link
								onClick={() => toggleNavbarStatus(false)}
								as={NavLink}
								to="/energy-consumption"
							>
								Energy consumption
							</Nav.Link>
							<Nav.Link onClick={() => toggleNavbarStatus(false)} as={NavLink} to="/monthly-report">
								Monthly report
							</Nav.Link>
							<Nav.Link onClick={() => toggleNavbarStatus(false)} as={NavLink} to="/weekly-report">
								Weekly report
							</Nav.Link>
							<NavDeviceList />
							<Nav.Link onClick={() => logout()}>Log out</Nav.Link>
						</Nav>
					</Navbar.Collapse>
				)}
			</Container>
		</Navbar>
	);
};

export default MainNavbar;
